import {
	DATA_BASE_URL,
	ENABLED_DISPLAYS_LOCAL_STORAGE_CACHE
} from '../../config';
import { cachingWrapper, request } from "../../api";

const BASE_URL = `${DATA_BASE_URL}api/public/broadcast-schedule`;

export const getChannel = async (channelSlug) => {
	const params = {
		'extend-with-takeover-configuration': true
	};

	const getChannelCallback = async () => await request({
		baseURL: BASE_URL,
		url: `channel/${channelSlug}`,
		params: { params }
	});

	return cachingWrapper({
		requestCallback: getChannelCallback,
		storageKey: `channel-${channelSlug}`
	});
};

export const getStore = async storeId => {
	const storeLoadingKey = `store-${storeId}`;

	try {
		const response = await fetch(`${DATA_BASE_URL}api/public/rise/stores/`);
		const stores = await response.json();

		if (!stores || !Array.isArray(stores) || stores.length === 0) {
			localStorage.removeItem(storeLoadingKey);
			return null;
		}

		const foundStore = stores.find(({id}) => id === storeId);

		if (foundStore && ENABLED_DISPLAYS_LOCAL_STORAGE_CACHE) {
			localStorage.setItem(storeLoadingKey, JSON.stringify(foundStore));
		}

		return foundStore;
	} catch (error) {
		console.warn(error);
		const cachedStore = JSON.parse(localStorage.getItem(storeLoadingKey));
		return cachedStore ?? null;
	}
};


